module.exports = "<div gw-loader=\"accountBillingDataPromise\">\r\n    <div\r\n            gw-account-billing\r\n            account-loaded=\"accountInfo.loaded\"\r\n            account-billing-summary=\"accountInfo.accountBillingSummary\"\r\n            account-billing-data=\"accountBillingData\"\r\n            account-billing-address=\"accountBillingAddress\"\r\n            account-number=\"{{accountNumber}}\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/account/billing.html
// module id = 779
// module chunks = 0